import {
  MAX_FPL_TEAM_ID,
  STORAGE_ITEMS,
  UNAUTHENTICATED_FPL_ID
} from '@lib/constants';
import { updateFplTeamId } from '@api-service/profile';
import { triggerToast } from '@components/atoms/toast';

export const getMyFPLId = async () => {
  const fplId =
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem(STORAGE_ITEMS.KEY_FPL_ID) ?? '{}')
      : null;
  return fplId;
};

export const setMyFPLId = async (fplId) => {
  localStorage.setItem(STORAGE_ITEMS.KEY_FPL_ID, JSON.stringify(fplId));
};

export const clearMyFPLId = () => {
  localStorage.removeItem(STORAGE_ITEMS.KEY_FPL_ID);
};

/**
 * Gets the effective FPL ID with backend > localStorage > '0' fallback.
 */
export const getFplId = (fplTeamId: number | null): string => {
  const localStorageFplId =
    typeof window !== 'undefined'
      ? localStorage.getItem(UNAUTHENTICATED_FPL_ID)
      : null;

  if (fplTeamId != null) {
    const fplTeamIdString = String(fplTeamId);
    if (localStorageFplId !== fplTeamIdString) {
      localStorage.setItem(UNAUTHENTICATED_FPL_ID, fplTeamIdString);
    }
    return fplTeamIdString;
  }

  if (localStorageFplId) {
    return localStorageFplId;
  }

  return '0';
};

export const handleFPLIDSubmit = async ({
  fplIdInput,
  accessToken,
  setFplIdInput,
  setResetModalIsOpen
}: {
  fplIdInput: string;
  accessToken: string | null;
  setFplIdInput: (input: string) => void;
  setResetModalIsOpen: (isOpen: boolean) => void;
}) => {
  if (Number(fplIdInput) > MAX_FPL_TEAM_ID) {
    triggerToast(
      {
        title: 'Unable to import team',
        subTitle:
          "You entered the game after the last deadline, so we can't fetch your team until the next GW.",
        variant: 'info'
      },
      { duration: 8000 }
    );
    setFplIdInput('');
    setResetModalIsOpen(false);
    return;
  }

  localStorage.setItem(UNAUTHENTICATED_FPL_ID, fplIdInput);

  if (accessToken) {
    const result = await updateFplTeamId(accessToken, Number(fplIdInput));
    if (!result.ok) {
      console.error('Failed to update FPL team ID:', result.message);
    }
  }

  setResetModalIsOpen(false);
};
